// node-modules
import _debounce from 'lodash/debounce';

// other
import { controller } from '@/scrollmagic/controller';

const getDuration = (container, element, offset) => {
  const duration = container.offsetHeight - element.offsetHeight - offset - document.querySelector('header').offsetHeight;
  return duration < 0 ? 0 : duration;
};


export function sticky() {
  const stickyContainers = document.querySelectorAll('[data-role="sticky-container"]');
  if (!stickyContainers.length) {
    return;
  }

  stickyContainers.forEach((stickyContainer) => {
    const stickyTarget = stickyContainer.querySelector('[data-role="sticky-target"]');
    const { offset, debounceTime = 100 } = stickyContainer.dataset;
    const scene = new ScrollMagic.Scene({
      triggerElement: stickyContainer,
      triggerHook: 'onLeave',
      duration: getDuration(stickyContainer, stickyTarget, offset || -50),
      offset: offset || -50,
    })
      .setPin(stickyTarget, {
        pushFollowers: false,
      })
      // .addIndicators('sticky target')
      .addTo(controller);

    const resize = () => {
      scene.duration(getDuration(stickyContainer, stickyTarget, scene.offset()));
      if (window.matchMedia('(max-width: 1023px)').matches) {
        scene.removePin(true);
      } else {
        scene.removePin(true);
        scene.setPin(stickyTarget, {
          pushFollowers: false,
        });
        scene.refresh();
      }
    };

    const resizeDebounced = _debounce(resize, debounceTime);

    window.addEventListener('resize', resizeDebounced);

    resize();
  });
}
